/* eslint-disable no-use-before-define */
import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';

import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    root: {
        '& label.Mui-focused': {
            color: 'white',
        },
        '& label': {
            color: 'white',
        },
    },
    inputRoot: {
        '& fieldset': {
        borderColor: 'white'
        },
        '&:hover fieldset': {
        borderColor: 'white!important',
        },
        '&.Mui-focused fieldset': {
        borderColor: 'white!important',
        },
        '& input': {
            color: 'white'
        }
    },
    endAdornment: {
        '& button': {
            color: 'white!important'
        }
    }
  });

export default function ComboBox(props) {
  const classes = useStyles();

  const onItemSelected = (event, value) => {
    props.onItemSelected(value);
  }

  return (
    <Autocomplete
      classes={{
          root: classes.root,
          inputRoot: classes.inputRoot,
          endAdornment: classes.endAdornment
      }}
      id="combo-box-demo"
      options={props.items.map(sn => ({name: sn.ob_uime, gid: sn.gid}))}
      getOptionLabel={(option) => option.name}
      onChange={onItemSelected}
      style={{ width: 300 }}
      renderInput={(params) => <TextField {...params} label="Omeji zapise na občino" size="small" variant="outlined" />}
    />
  );
}